// extracted by mini-css-extract-plugin
export default {"container":"FeesOrderDetail_container__WUk2O","title":"FeesOrderDetail_title__IFwat","subTitle":"FeesOrderDetail_subTitle__fYdl8","textTotal":"FeesOrderDetail_textTotal__IQnCp"};